import { ReactNode } from 'react';
import { merge } from 'lodash';
import { DataGridProps as MuiDataGridProps, useGridApiRef } from '@mui/x-data-grid';

import { DataGridToolbar } from './DataGridToolbar';
import { DataGridProvider } from './DataGridContext';
import { DataGridComponent } from './DataGridComponent';
import { DEFAULT_PAGE_SIZE_OPTIONS, DEFAULT_SLOT_PROPS } from './DataGrid.const';
import { Box } from '@mui/material';

interface DataGridProps<T> extends Omit<MuiDataGridProps, 'rows' | 'loading'> {
  dataTestId?: string;
  query: any;
  tools?: ReactNode;
  actions?: ReactNode;
  parentId?: number;
}

export const DataGrid = <T,>({
  query,
  tools,
  actions,
  parentId,
  dataTestId = 'data-grid',
  editMode = 'row',
  pagination = true,
  slotProps = DEFAULT_SLOT_PROPS,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  ...props
}: DataGridProps<T>) => {
  const apiRef = useGridApiRef();
  const sx = merge({
    height: 'calc(100vh - 152px)',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  }, props.sx);

  return (
    <DataGridProvider query={query} id={parentId}>
      <Box sx={sx}>
        <DataGridToolbar apiRef={apiRef} tools={tools} actions={actions} />
        <DataGridComponent
          apiRef={apiRef}
          dataTestId={dataTestId}
          editMode={editMode}
          pagination={pagination}
          slotProps={slotProps}
          pageSizeOptions={pageSizeOptions}
          {...props}
        />
      </Box>
    </DataGridProvider>
  );
};

export default DataGrid;
